import React from "react"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import { Grid, Typography } from "@material-ui/core"
import { useTrack } from "@hackler/react-sdk"
import usePlatform from "../../../hooks/usePlatform"
import Section from "../../../components/Section/Section"
import { useHackleFeatureFlags } from "../../../hooks/useHackleFeatureFlags"

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#F9FAFB",
      padding: "24px 0",
      [theme.breakpoints.up("md")]: {
        padding: "32px 24px",
      },
    },
    container: {
      alignItems: "center",
    },
    h2: {
      fontSize: "24px",
      paddingBottom: 16,
      [theme.breakpoints.up("md")]: {
        fontSize: "40px",
        paddingBottom: 0,
      },
    },
    caption: {
      fontSize: "14px",
      color: "rgba(0,0,0,0.6)",
      [theme.breakpoints.up("md")]: {
        fontSize: "20px",
      },
    },
    link: {
      backgroundColor: theme.palette.common.white,
      border: "none",
      borderRadius: "8px",
      color: "rgba(0, 0, 0, 0.6)",
      padding: "8px 16px",
      cursor: "pointer",
      outline: "none",
      fontSize: "14px",
      [theme.breakpoints.up("md")]: {
        fontSize: "20px",
        padding: "12px 20px",
      },
    },
    button: {
      backgroundColor: "#E8EFFC",
      border: "none",
      borderRadius: "8px",
      color: theme.palette.primary.main,
      padding: "8px 16px",
      cursor: "pointer",
      outline: "none",
      fontSize: "14px",
      [theme.breakpoints.up("md")]: {
        fontSize: "20px",
        padding: "12px 20px",
      },
    },
  })
)

export default function Webinar() {
  const track = useTrack()
  const classes = useStyles()
  const { isMobile } = usePlatform()
  const { webinarRequestOn } = useHackleFeatureFlags()

  return (
    <Section
      spacing={isMobile ? 0 : 5}
      containerDirection={isMobile ? "column" : "row"}
      className={classes.root}
      containerClassName={classes.container}>
      <Grid
        item
        xs={isMobile ? 12 : 6}
        style={{ textAlign: isMobile ? "center" : "left" }}
        container
        direction={"column"}
        alignItems={isMobile ? "center" : "flex-start"}
        justify={isMobile ? "center" : "flex-start"}>
        <Typography variant={"caption"} className={classes.caption}>
          핵클 Tech 웨비나를 통해 더 자세히 알아보세요!
        </Typography>
        <Typography variant={"h2"} className={classes.h2}>
          <strong>참여 기업수 2,400개 이상</strong>
        </Typography>
      </Grid>
      <Grid
        item
        xs={isMobile ? 12 : 6}
        style={{ textAlign: "center", paddingBottom: isMobile ? 6 : 20 }}
        container
        alignItems={"center"}
        justify={"flex-end"}>
        <Grid container spacing={isMobile ? 1 : 2} justify={isMobile ? "center" : "flex-end"}>
          <Grid item>
            <button
              className={classes.link}
              onClick={() => {
                track({ key: "homepage_home_section_1_0_oneday_video_click" })
                window.open("https://youtu.be/IQxaV-HNjog", "_blank")
              }}>
              <strong>웨비나 다시보기</strong>
            </button>
          </Grid>
          {webinarRequestOn && (
            <Grid item>
              <button
                className={classes.button}
                onClick={() => {
                  track({ key: "homepage_home_section_1_0_oneday_click" })
                  window.open("https://apply.hackle.io", "_blank")
                }}>
                <strong>웨비나 신청하기</strong>
              </button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Section>
  )
}
